/**
 * 聊天模块 API
 * - HTTP 接口负责房间列表、历史消息、创建私聊房间
 * - Socket.IO 只负责实时加入房间和收发消息
 */
import request from './request'
import type {ChatMessage, ChatRoom, ChatUnreadSummary} from '@/types'

export const chatApi = {
  /** 创建私域聊天室，返回可分享的房间编号 */
  createPrivateRoom(data: {name?: string; password: string}) {
    return request.post<unknown, ChatRoom>('/chat/rooms/private', data)
  },

  /** 创建或打开 1v1 私信聊天室 */
  sendDirectMessage(data: {recipientId: number; content?: string; imageFileId?: number | null}) {
    return request.post<unknown, ChatMessage>('/chat/rooms/direct', data)
  },

  /** 获取当前用户的聊天室列表 */
  getRooms() {
    return request.get<unknown, ChatRoom[]>('/chat/rooms')
  },

  getUnreadSummary() {
    return request.get<unknown, ChatUnreadSummary>('/chat/unread-summary')
  },

  /** 输入房间编号和 4 位密码加入私域聊天室 */
  joinPrivateRoom(data: {code: string; password: string}) {
    return request.post<unknown, ChatRoom>('/chat/rooms/join', data)
  },

  /** 创建或获取当前用户的客服聊天室 */
  createSupportRoom() {
    return request.post<unknown, ChatRoom>('/chat/rooms/support')
  },

  /** 获取房间历史消息 */
  getMessages(roomId: number) {
    return request.get<unknown, ChatMessage[]>(`/chat/rooms/${roomId}/messages`)
  },

  markRoomRead(roomId: number) {
    return request.patch<unknown, ChatUnreadSummary>(`/chat/rooms/${roomId}/read`)
  },

  /** 从当前用户的私信列表删除会话，不解散真实聊天室，也不删除聊天记录 */
  deleteDirectRoom(roomId: number) {
    return request.delete<unknown, void>(`/chat/rooms/${roomId}/direct`)
  },

  /** 解散聊天室：房主可解散自己的房间，管理员可解散所有用户房间 */
  deleteRoom(roomId: number) {
    return request.delete<unknown, void>(`/chat/rooms/${roomId}`)
  }
}
